// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box } from "@outschool/backpack";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import {
  ListingCarousel,
  searchListingsQuery
} from "@outschool/ui-components-website";
import { PageWidthSection } from "@outschool/ui-legacy-component-library";
import { responsive } from "@outschool/ui-utils";
import React from "react";

import { useTimeZone } from "../providers/TimeZoneProvider";

interface SearchListingsCarouselProps {
  title: string;
  searchFilters: any;
  carouselRowNum: number;
  trackingLabel: string;
  batchKey?: string;
  addTopPadding?: boolean;
}

const SearchListingsCarousel = React.forwardRef(
  (
    {
      title,
      trackingLabel,
      searchFilters,
      batchKey,
      carouselRowNum,
      addTopPadding
    }: SearchListingsCarouselProps,
    ref
  ) => {
    const { isLoggedIn } = useSession();
    const { timeZone } = useTimeZone();

    const {
      data: { searchListings: { listings } } = {
        searchListings: { listings: [] }
      }
    } = useQueryWithPreviousData(searchListingsQuery, {
      variables: {
        searchFilters: { ...searchFilters, timeZone },
        limit: 10,
        skipRating: false,
        withRecentReviews: false
      },
      context: { batchKey }
    });

    return listings.length > 0 ? (
      <PageWidthSection
        fullBleed
        sx={{
          paddingTop: !!addTopPadding ? "large" : null,
          paddingY: responsive({ medium: "large", default: "medium" })
        }}
        ref={ref}
      >
        <ListingCarousel
          sx={{ padding: 0 }}
          title={title}
          listings={listings}
          trackingLabel={trackingLabel}
          carouselRowNum={carouselRowNum}
          openInSSRForLoggedOutUsers={!isLoggedIn}
        />
        <Box
          sx={{
            textAlign: "center",
            marginTop: "1em",
            marginBottom: "2em"
          }}
        ></Box>
      </PageWidthSection>
    ) : null;
  }
);

export default SearchListingsCarousel;
